import { GetServerSideProps } from 'next';

import { DoctorPage } from '~/components/Doctor';
import { getTranslations } from '~/lib/next-i18next';

const Doctor = () => {
  return <DoctorPage />;
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => ({
  props: {
    ...(await getTranslations({ locale })),
  },
});

export default Doctor;
